import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export interface CursorPositionContextValue {
  cursorPosition: { lat: string; lon: string } | null;
  setCursorPosition: Dispatch<
    SetStateAction<{ lat: string; lon: string } | null>
  >;
}

const CursorPositionContext = createContext<
  CursorPositionContextValue | undefined
>(undefined);

export const CursorPositionProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [cursorPosition, setCursorPosition] = useState<{
    lat: string;
    lon: string;
  } | null>(null);

  return (
    <CursorPositionContext.Provider
      value={{ cursorPosition, setCursorPosition }}
    >
      {children}
    </CursorPositionContext.Provider>
  );
};

export const useCursorPosition = () => {
  const context = useContext(CursorPositionContext);
  if (!context) {
    throw new Error(
      'useCursorPosition must be used within a CursorPositionProvider',
    );
  }
  return context;
};
